/* Diamond Studio — search dialog helpers (2026-09-29), every page.
   1. Quick links under the search field before anything is typed.
   2. Live suggestions while typing (Shopify predictive search): matching collections and up to six pieces
      with photo and price. Arrow keys move between suggestions.
   3. "See all results" always submits the typed search. */
(() => {
  'use strict';
  if (window.DSSearchCRO) return;
  window.DSSearchCRO = {version: '2026-09-29'};

  const QUICK = [
    ['Oval engagement rings', 'collections/oval-cut-lab-grown-diamond-engagement-rings'],
    ['Round engagement rings', 'collections/round-cut-lab-grown-diamond-engagement-rings'],
    ['Halo rings', 'collections/lab-grown-halo-rings'],
    ['Wedding bands', 'collections/lab-grown-diamond-fashion-bands'],
    ['Tennis bracelets', 'search?q=tennis+bracelet&type=product'],
    ['Stud earrings', 'search?q=stud+earrings&type=product']
  ];
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c]));
  const root = () => (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const track = (action, extra) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({event: 'ds_search_cro', action}, extra || {}));
  };
  const money = value => {
    const cur = window.DS_CRO?.currency || 'USD';
    const n = Number(value);
    if (!Number.isFinite(n)) return '';
    const amount = n.toLocaleString('en-US', {minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2});
    return (cur === 'USD' ? '$' : '') + amount + (window.DS_CRO?.country === 'US' && cur === 'USD' ? '' : ' ' + cur);
  };
  const thumb = src => {
    if (!src) return '';
    const base = src.startsWith('//') ? 'https:' + src : src;
    return base + (base.includes('?') ? '&' : '?') + 'width=120';
  };
  const ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 12h16m-6-6 6 6-6 6"/></svg>';

  function setup() {
    const dialog = document.getElementById('ds-header-search');
    const input = dialog?.querySelector('input[name="q"]');
    const form = input?.form;
    if (!form || dialog.querySelector('.ds-sc-panel')) return !!form;
    const panel = document.createElement('div');
    panel.className = 'ds-sc-panel';
    panel.innerHTML = '<div class="ds-sc-quick"><p class="ds-sc-label" id="ds-sc-quick-label">Start with</p><ul class="ds-sc-chips" role="list" aria-labelledby="ds-sc-quick-label">' +
      QUICK.map(([label, path]) => '<li><a href="' + esc(root() + path) + '" data-ds-sc="quick">' + esc(label) + '</a></li>').join('') + '</ul></div>' +
      '<div class="ds-sc-results" hidden></div><p class="ds-sc-status" role="status" aria-live="polite"></p>';
    form.after(panel);
    const quick = panel.querySelector('.ds-sc-quick');
    const results = panel.querySelector('.ds-sc-results');
    const status = panel.querySelector('.ds-sc-status');
    input.setAttribute('aria-describedby', 'ds-sc-quick-label');

    let ctrl = null;
    let timer = 0;
    let last = '';
    const allLink = q => '<a class="ds-sc-all" href="' + esc(root() + 'search?q=' + encodeURIComponent(q) + '&type=product') + '" data-ds-sc="all">See all results for &ldquo;' + esc(q) + '&rdquo; ' + ARROW + '</a>';

    async function run() {
      const q = input.value.trim();
      if (q === last) return;
      last = q;
      if (q.length < 2) {
        ctrl?.abort();
        results.hidden = true;
        results.innerHTML = '';
        quick.hidden = false;
        status.textContent = '';
        return;
      }
      ctrl?.abort();
      ctrl = new AbortController();
      const url = root() + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=hide';
      let data = null;
      try { data = await fetch(url, {signal: ctrl.signal, credentials: 'same-origin'}).then(r => r.ok ? r.json() : null); } catch (e) { return; }
      if (q !== input.value.trim()) return;
      const found = data?.resources?.results || {};
      const products = (found.products || []).slice(0, 6);
      const collections = (found.collections || []).slice(0, 3);
      quick.hidden = true;
      results.hidden = false;
      if (!products.length && !collections.length) {
        results.innerHTML = '<p class="ds-sc-empty">No quick matches for &ldquo;' + esc(q) + '&rdquo;.</p>' + allLink(q);
        status.textContent = 'No suggestions. Press Enter to search the whole collection.';
        return;
      }
      results.innerHTML =
        (collections.length ? '<p class="ds-sc-label">Collections</p><ul class="ds-sc-chips" role="list">' + collections.map(c =>
          '<li><a href="' + esc(c.url) + '" data-ds-sc="collection">' + esc(c.title) + '</a></li>').join('') + '</ul>' : '') +
        (products.length ? '<p class="ds-sc-label">Pieces</p><ul class="ds-sc-products" role="list">' + products.map(p => {
          const img = thumb(p.image || p.featured_image?.url);
          const was = Number(p.compare_at_price_min) > Number(p.price) ? '<del>' + esc(money(p.compare_at_price_min)) + '</del>' : '';
          return '<li><a href="' + esc(p.url) + '" data-ds-sc="product">' +
            '<span class="ds-sc-img">' + (img ? '<img src="' + esc(img) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</span>' +
            '<span class="ds-sc-name">' + esc(p.title) + '</span>' +
            '<span class="ds-sc-price"><strong>' + esc(money(p.price)) + '</strong>' + was + '</span></a></li>';
        }).join('') + '</ul>' : '') + allLink(q);
      status.textContent = (products.length + collections.length) + ' suggestions. Use the arrow keys to move through them.';
    }

    input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(run, 180); });
    const links = () => [...panel.querySelectorAll('a')].filter(a => !a.closest('[hidden]'));
    input.addEventListener('keydown', event => {
      if (event.key !== 'ArrowDown') return;
      const first = links()[0];
      if (first) { event.preventDefault(); first.focus(); }
    });
    panel.addEventListener('keydown', event => {
      if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
      const list = links();
      const i = list.indexOf(document.activeElement);
      if (i < 0) return;
      event.preventDefault();
      const next = event.key === 'ArrowDown' ? list[i + 1] : list[i - 1];
      if (next) next.focus(); else if (event.key === 'ArrowUp') input.focus();
    });
    panel.addEventListener('click', event => {
      const link = event.target.closest('[data-ds-sc]');
      if (link) track(link.dataset.dsSc, {term: input.value.trim().slice(0, 60)});
    });
    return true;
  }

  function start() {
    if (setup()) return;
    // The header can build the search dialog after this script runs.
    const observer = new MutationObserver(() => { if (setup()) observer.disconnect(); });
    observer.observe(document.body, {childList: true, subtree: true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
